import { takeEvery, call, put } from "redux-saga/effects";
import { GET_EMP_DETAILDATA, SET_EMP_DETAILDATA } from "../actions";
import empApi from "../utils/employeeAxios";
export const watchGetEmpDetailData = function* () {
  yield takeEvery(GET_EMP_DETAILDATA, workerGetEmpDetailData);
};

function* workerGetEmpDetailData(reqData) {
  try {
    const { url, params } = reqData.datas;
    const uri = `${url}?${params || ""}`;

    const result = yield call(empApi.get, uri);

    yield put({ type: SET_EMP_DETAILDATA, value: [result.data] });
  } catch (e) {
    console.error("API error:", e);
    const returnError = e?.response?.data || [];
    yield put({ type: SET_EMP_DETAILDATA, value: [returnError] });
  }
}
